import { PayloadAction } from "@reduxjs/toolkit";

import { StationsState } from '../../types';

export const setFilteredStationsLoadingStatus = (
  state: StationsState,
  action: PayloadAction<StationsState['filteredStations']['loadingStatus']>
) => {
  state.filteredStations.loadingStatus = action.payload;
};
